import { render, staticRenderFns } from "./DadosBancarios.vue?vue&type=template&id=f48303b0&scoped=true&"
import script from "./DadosBancarios.vue?vue&type=script&lang=ts&"
export * from "./DadosBancarios.vue?vue&type=script&lang=ts&"
import style0 from "./DadosBancarios.vue?vue&type=style&index=0&id=f48303b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f48303b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VDialog,VFlex,VIcon})
